var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.3333 2.54666L17.4533 0.666656L9.99996 8.11999L2.54663 0.666656L0.666626 2.54666L8.11996 9.99999L0.666626 17.4533L2.54663 19.3333L9.99996 11.88L17.4533 19.3333L19.3333 17.4533L11.88 9.99999L19.3333 2.54666Z","fill":"#00538B","fillOpacity":"0.77"}));
}

Close.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Close;

Close.default = Close;
